import React from 'react';
import {
  Bug,
  Lightbulb,
  MessageSquare,
  Palette,
  Heart,
  Flame,
  AlertTriangle,
  AlertCircle,
  Zap,
  Star,
} from 'lucide-react';

export const MAX_FILE_SIZE_MB = 2;
export const MAX_FILES = 3;

export const PRIORITY_OPTIONS = [
  {
    value: 'showstopper',
    label: 'Showstopper',
    icon: AlertTriangle,
    color: 'bg-red-100 border-red-300 text-red-700',
    description: 'Blocks critical functionality',
  },
  {
    value: 'urgent',
    label: 'Urgent',
    icon: AlertCircle,
    color: 'bg-orange-100 border-orange-300 text-orange-700',
    description: 'Important but workaround exists',
  },
  {
    value: 'normal',
    label: 'Normal',
    icon: Zap,
    color: 'bg-blue-100 border-blue-300 text-blue-700',
    description: 'Standard priority',
  },
  {
    value: 'nice-to-have',
    label: 'Nice to Have',
    icon: Star,
    color: 'bg-green-100 border-green-300 text-green-700',
    description: 'Low priority enhancement',
  },
];

export const TYPE_GROUPS = [
  ['bug', 'feature', 'suggestion'],
  ['design', 'compliment', 'flame'],
];

export const TYPE_COLOR_MAP = {
  bug: 'bg-red-50 border-red-300 text-red-700',
  feature: 'bg-blue-50 border-blue-300 text-blue-700',
  suggestion: 'bg-green-50 border-green-300 text-green-700',
  design: 'bg-purple-50 border-purple-300 text-purple-700',
  compliment: 'bg-pink-50 border-pink-300 text-pink-700',
  flame: 'bg-orange-50 border-orange-300 text-orange-700',
};

export const renderTypeIcon = (type) => {
  switch (type) {
    case 'bug':
      return <Bug className="h-4 w-4" />;
    case 'feature':
      return <Lightbulb className="h-4 w-4" />;
    case 'suggestion':
      return <MessageSquare className="h-4 w-4" />;
    case 'design':
      return <Palette className="h-4 w-4" />;
    case 'compliment':
      return <Heart className="h-4 w-4" />;
    case 'flame':
      return <Flame className="h-4 w-4" />;
    default:
      return <Bug className="h-4 w-4" />;
  }
};
